import { useRef, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";

import config from "@config";
import useAccount from "@hooks/useAccount";
import useMediaQuery from "@hooks/useMediaQuery";
import type { MyLocale } from "@i18n";
import { useI18n } from "next-rosetta";

import ExternalLink from "@components/ExternalLink";

const addTokenToWallet =
	(tokenSymbol: string, tokenAddress: string) => async () => {
		if (window.ethereum) {
			try {
				await window.ethereum.req({
					method: "wallet_watchAsset",
					params: {
						options: {
							address: tokenAddress,
							decimals: config.web3.vpndTokenDecimals,
							image:
								"https://i.ibb.co/MsQLHyP/logo-token-coin-vaporfi-200x200.png",
							symbol: tokenSymbol,
						},
						type: "ERC20",
					},
				});
			} catch (error) {
				console.log(error);
			}
		}
	};

export default function TokenMenu() {
	const [popperOpen, setPopperOpen] = useState(false);
	const timeout = useRef<number>(-1);
	const anchorEl = useRef<typeof Box>(null);
	const { active } = useAccount();
	const { isMobile } = useMediaQuery();
	const i18n = useI18n<MyLocale>();
	const handleClick = (event: any, shouldOpen: boolean) => {
		window.clearTimeout(timeout.current);
		timeout.current = window.setTimeout(() => {
			setPopperOpen(shouldOpen);
		}, 200);
	};

	return (
		<Box
			ref={anchorEl}
			onMouseEnter={(e) => handleClick(e, true)}
			onMouseLeave={(e) => handleClick(e, false)}
			sx={{ marginRight: 2 }}
		>
			<Button
				disableElevation
				sx={{
					":hover": { border: "2px solid white" },
					alignItems: "center",
					backgroundColor: "transparent",
					color: "white",
					display: "flex",
					flexDirection: "row",
					gap: 1,
				}}
			>
				VPND
			</Button>

			<Popper
				open={popperOpen}
				// @ts-expect-error: TODO
				anchorEl={anchorEl.current}
				transition
				onMouseEnter={(e) => handleClick(e, true)}
				onMouseLeave={(e) => handleClick(e, false)}
			>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={200}>
						<Paper>
							<List sx={{ marginTop: 2 }}>
								<ExternalLink
									href={`https://app.vapordex.io/swap?inputCurrency=AVAX&outputCurrency=${config.web3.vpndAddress}`}
									target="_blank"
									rel="noreferrer"
								>
									<ListItemButton>
										<ListItemText>Buy on VaporDEX</ListItemText>
									</ListItemButton>
								</ExternalLink>
							</List>
							{active && !isMobile && (
								<>
									<Divider />
									<List>
										<ListItemButton
											alignItems="center"
											onClick={addTokenToWallet(
												"VPND",
												config.web3.vpndAddress,
											)}
										>
											<ListItemText sx={{ textAlign: "center" }}>
												{i18n.t("tokenMenu.addToWallet")}
											</ListItemText>
										</ListItemButton>
									</List>
								</>
							)}
						</Paper>
					</Fade>
				)}
			</Popper>
		</Box>
	);
}
